export default "__VITE_ASSET__9f7c66c5__"